<template>
  <div class="adv-list">
    <!-- 视频卡片 -->
    <div v-for="video in videoList" :key="video.id" class="adv-card">
      <!-- 左侧封面 -->
      <div class="adv-cover">
        <img :src="video.img || 'https://picsum.photos/seed/' + video.id + '/400/300'" :alt="video.title" class="cover-image" />
        <div class="cover-overlay">
          <div class="play-icon">
            <PlayCircleOutlined :style="{ fontSize: '48px', color: '#fff' }" />
          </div>
        </div>
        <div
          class="status-tag"
          :class="{
            'tag-upcoming': video.status === 3,
            'tag-ongoing': video.status === 1,
            'tag-ended': video.status === 5
          }"
        >
          {{ video.status === 1 ? $t('_wdtg._jxz') : '' }}
        </div>
      </div>

      <!-- 右侧信息 -->
      <div class="adv-info">
        <div class="info-top">
          <h3 class="adv-title">{{ video.title }}</h3>
          <div class="adv-meta">
            <span class="meta-tag">
              <i class="fas fa-tag"></i>
              {{ $t('_ggtf._hdbm') }}: {{ video.code }}
            </span>
            <span class="meta-tag">
              <i class="fas fa-coins"></i>
              {{ $t('_ggtf._zdtz') }}: <strong>${{ video.price_min }}</strong>
            </span>
            <span class="meta-tag">
              <i class="fas fa-calendar-day"></i>
              {{ $t('_wdtg._hdts') }}: {{ video.days || 0 }} {{ $t('_ggtf._tian') }}
            </span>
          </div>
        </div>

        <!-- 倒计时 -->
        <div class="countdown" v-if="video.begin_seconds > 0 || video.end_seconds > 0">
          <div class="countdown-label">
            <span class="label-dot" :class="{ 'dot-begin': video.begin_seconds > 0, 'dot-end': video.end_seconds > 0 }"></span>
            {{ video.begin_seconds > 0 ? $t('_ggtf._kssj') : $t('_ggtf._jssj') }}
          </div>
          <div class="countdown-timer">
            <div class="time-block">
              <span class="time-num">{{ video.begin_seconds > 0 ? video.begin.days : video.end.days }}</span>
              <span class="time-label">{{ $t('_ggtf._tian') }}</span>
            </div>
            <span class="time-colon">:</span>
            <div class="time-block">
              <span class="time-num">{{ video.begin_seconds > 0 ? video.begin.hours : video.end.hours }}</span>
              <span class="time-label">时</span>
            </div>
            <span class="time-colon">:</span>
            <div class="time-block">
              <span class="time-num">{{ video.begin_seconds > 0 ? video.begin.minutes : video.end.minutes }}</span>
              <span class="time-label">分</span>
            </div>
            <span class="time-colon">:</span>
            <div class="time-block">
              <span class="time-num">{{ video.begin_seconds > 0 ? video.begin.seconds : video.end.seconds }}</span>
              <span class="time-label">秒</span>
            </div>
          </div>
          <div class="countdown-time">
            {{ video.begin_seconds > 0 ? $t('_ggtf._kssj') : $t('_ggtf._jssj') }}:
            {{ formatDate(video.begin_seconds > 0 ? video.begin_time : video.end_time) }}
          </div>
        </div>

        <!-- VIP要求 -->
        <div class="vip-requirement">
          <i class="fas fa-crown"></i>
          {{ $t('_ggtf._ddvp', { a: video.level, b: video.pre_num }) }}
        </div>

        <!-- 底部操作 -->
        <div class="action-section">
          <button class="btn-buy" @click="onBuy(video)">
            <i class="fas fa-rocket"></i>
            {{ $t('_sp._tliu') }}
          </button>
        </div>
      </div>
    </div>

    <!-- 加载更多 -->
    <div class="load-more">
      <button class="load-btn" v-if="hasMore" @click="loadMore" :disabled="loading">
        <span class="spinner" v-if="loading"></span>
        {{ loading ? $t('_a._jzz') : $t('_a._jzgd') }}
      </button>
      <div class="no-more" v-else>
        <i class="fas fa-flag-checkered"></i>
        {{ $t('_ggtf._mygdl') }}
      </div>
    </div>
  </div>
</template>

<script>
import { PlayCircleOutlined } from '@ant-design/icons-vue'

export default {
  name: 'VideoAdvList',
  components: { PlayCircleOutlined },
  props: {
    searchKeyword: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      hasMore: true,
      page: 1,
      size: 6,
      videoList: [],
      countdownTimers: {},

      // 搜索相关
      searchTimer: null, // 防抖定时器
      abortController: null, // 请求取消控制器
      currentKeyword: '' // 当前搜索的关键词
    }
  },
  mounted() {
    this.getList()
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
    Object.values(this.countdownTimers).forEach((timer) => clearInterval(timer))

    // 清理定时器和取消请求
    clearTimeout(this.searchTimer)
    this.cancelRequest()
  },
  // 2. 监听 searchKeyword 变化
  watch: {
    searchKeyword: {
      handler(newVal) {
        // 清除之前的防抖定时器
        clearTimeout(this.searchTimer)

        // 如果关键词为空或长度小于2，重置列表
        if (!newVal || newVal.trim().length < 1) {
          this.currentKeyword = ''
         this.getList(1)
          return
        }

        // 设置防抖，300ms 后执行搜索
        this.searchTimer = setTimeout(() => {
          this.currentKeyword = newVal.trim()
          this.getList(1, this.currentKeyword)
        }, 300)
      },
      immediate: true
    }
  },
  methods: {
    // 取消当前请求
    cancelRequest() {
      if (this.abortController) {
        this.abortController.abort()
        this.abortController = null
      }
    },

    // 重置列表
    resetList() {
      // this.videoList = []
      this.page = 1
      this.hasMore = true
      this.loading = false
      this.cancelRequest()
    },
    handleScroll() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      const windowHeight = window.innerHeight
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight

      if (scrollTop + windowHeight >= scrollHeight - 100 && !this.loading && this.hasMore) {
        this.loadMore()
      }
    },

    loadMore() {
      this.getList()
    },

    onBuy(item) {
      this.$router.push({
        path: '/adv/buy',
        query: { code: item.code }
      })
    },

    getList(page = 0, keyword = '') {
      if (this.loading) return

      if (page > 0) {
        this.videoList = []
        this.page = page
        this.hasMore = true
      }

      this.loading = true

      this.$api.videoAdv
        .getVideoAdvList({
          page: this.page,
          size: this.size,
          keyword: keyword
        })
        .then((res) => {
          this.loading = false
          this.page++

          if (res.data.length === 0) {
            this.hasMore = false
            return
          }

          res.data.forEach((item) => {
            item.begin = this.$common.formatTimeRemaining(item.begin_seconds) || { days: 0, hours: 0, minutes: 0, seconds: 0 }
            item.end = this.$common.formatTimeRemaining(item.end_seconds) || { days: 0, hours: 0, minutes: 0, seconds: 0 }
            this.videoList.push(item)
            this.startCountdown(item)
          })

          this.hasMore = res.data.length >= this.size
        })
        .catch(() => {
          this.loading = false
        })
    },

    startCountdown(item) {
      const key = item.id
      if (this.countdownTimers[key]) {
        clearInterval(this.countdownTimers[key])
      }

      this.countdownTimers[key] = setInterval(() => {
        let target = item.begin_seconds > 0 ? item.begin : item.end
        let seconds = parseInt(target.seconds) || 0
        let minutes = parseInt(target.minutes) || 0
        let hours = parseInt(target.hours) || 0
        let days = parseInt(target.days) || 0

        seconds--
        if (seconds < 0) {
          seconds = 59
          minutes--
          if (minutes < 0) {
            minutes = 59
            hours--
            if (hours < 0) {
              hours = 23
              days--
            }
          }
        }

        if (days < 0) {
          clearInterval(this.countdownTimers[key])
          return
        }

        const update = { days, hours, minutes, seconds }
        Object.keys(update).forEach((k) => {
          target[k] = String(update[k]).padStart(2, '0')
        })
      }, 1000)
    },

    formatDate(date) {
      if (!date) return '--'
      const d = new Date(date)
      return d.toLocaleDateString('zh-CN') + ' ' + d.toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit' })
    }
  }
}
</script>

<style scoped>
/* ============================================================
   广告列表 - 暗色主题
   ============================================================ */

.adv-list {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0;
}

/* ============================================================
   卡片
   ============================================================ */
.adv-card {
  display: flex;
  background: #0f1419;
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 20px;
  border: 1px solid #1a1f26;
  transition: all 0.3s ease;
}

.adv-card:hover {
  border-color: #e50914;
  transform: translateY(-3px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
}

/* ============================================================
   封面
   ============================================================ */
.adv-cover {
  position: relative;
  flex: 0 0 280px;
  height: 200px;
  overflow: hidden;
  background: #0a0d0f;
  cursor: pointer;
}

.cover-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.adv-card:hover .cover-image {
  transform: scale(1.05);
}

.cover-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.adv-card:hover .cover-overlay {
  opacity: 1;
}

.play-icon {
  width: 64px;
  height: 64px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

.adv-card:hover .play-icon {
  transform: scale(1.1);
}

/* 状态标签 */
.status-tag {
  position: absolute;
  top: 12px;
  right: 12px;
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.3px;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  color: #fff;
}

.tag-upcoming {
  background: #f59e0b;
}

.tag-ongoing {
  background: #10b981;
}

.tag-ended {
  background: #ef4444;
}

/* ============================================================
   信息区
   ============================================================ */
.adv-info {
  flex: 1;
  padding: 18px 22px 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
}

.info-top {
  flex: 1;
}

.adv-title {
  font-size: 18px;
  font-weight: 700;
  color: #e8edf2;
  margin: 0 0 10px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.adv-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 16px;
  margin-bottom: 12px;
}

.meta-tag {
  font-size: 13px;
  color: #8a949f;
  display: flex;
  align-items: center;
  gap: 5px;
}

.meta-tag i {
  font-size: 13px;
  color: #5a6672;
}

.meta-tag strong {
  color: #ffb300;
  font-weight: 700;
}

/* ============================================================
   倒计时
   ============================================================ */
.countdown {
  background: #0a0d0f;
  border-radius: 12px;
  padding: 12px 16px;
  margin-bottom: 12px;
  border: 1px solid #141a20;
}

.countdown-label {
  font-size: 13px;
  font-weight: 600;
  color: #8a949f;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.label-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}

.dot-begin {
  background: #f59e0b;
  animation: pulse-dot 1.2s ease-in-out infinite;
}

.dot-end {
  background: #ef4444;
  animation: pulse-dot 1.2s ease-in-out infinite;
}

@keyframes pulse-dot {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.4;
    transform: scale(0.8);
  }
}

.countdown-timer {
  display: flex;
  align-items: center;
  gap: 4px;
}

.time-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #141a20;
  border-radius: 8px;
  padding: 4px 10px;
  min-width: 44px;
}

.time-num {
  font-size: 22px;
  font-weight: 800;
  color: #e8edf2;
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
}

.time-label {
  font-size: 10px;
  color: #5a6672;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.time-colon {
  font-size: 22px;
  font-weight: 700;
  color: #2a3138;
  padding: 0 2px;
}

.countdown-time {
  font-size: 12px;
  color: #5a6672;
  margin-top: 6px;
}

/* ============================================================
   VIP要求
   ============================================================ */
.vip-requirement {
  font-size: 13px;
  color: #8a949f;
  padding: 8px 14px;
  background: rgba(255, 179, 0, 0.06);
  border-radius: 10px;
  border: 1px solid rgba(255, 179, 0, 0.08);
  margin-bottom: 14px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  align-self: flex-start;
}

.vip-requirement i {
  color: #ffb300;
  font-size: 15px;
}

/* ============================================================
   操作按钮
   ============================================================ */
.action-section {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  align-items: center;
  padding-top: 12px;
  border-top: 1px solid #141a20;
}

.btn-buy {
  padding: 10px 32px;
  border: none;
  border-radius: 30px;
  background: linear-gradient(135deg, #e50914, #b20710);
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 16px rgba(229, 9, 20, 0.25);
}

.btn-buy:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(229, 9, 20, 0.35);
}

.btn-buy:active {
  transform: translateY(0);
}

.btn-buy i {
  font-size: 14px;
}

/* ============================================================
   加载更多
   ============================================================ */
.load-more {
  text-align: center;
  padding: 30px 0 10px;
}

.load-btn {
  padding: 12px 40px;
  border: 1px solid #1a1f26;
  border-radius: 30px;
  background: #0f1419;
  color: #8a949f;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.load-btn:hover:not(:disabled) {
  border-color: #e50914;
  color: #e8edf2;
}

.load-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.spinner {
  width: 18px;
  height: 18px;
  border: 2px solid #1a1f26;
  border-top-color: #e50914;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  display: inline-block;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.no-more {
  color: #5a6672;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.no-more i {
  font-size: 16px;
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 768px) {
  .adv-card {
    flex-direction: column;
  }

  .adv-cover {
    flex: 0 0 auto;
    height: 180px;
    width: 100%;
  }

  .adv-info {
    padding: 16px 18px;
  }

  .adv-title {
    font-size: 16px;
  }

  .adv-meta {
    gap: 4px 12px;
  }

  .countdown-timer {
    gap: 2px;
  }

  .time-block {
    padding: 3px 8px;
    min-width: 36px;
  }

  .time-num {
    font-size: 18px;
  }

  .time-colon {
    font-size: 18px;
  }

  .action-section {
    flex-wrap: wrap;
    justify-content: stretch;
  }

  .btn-buy {
    flex: 1;
    justify-content: center;
    padding: 10px 16px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .adv-cover {
    height: 140px;
  }

  .adv-info {
    padding: 12px 14px;
  }

  .adv-title {
    font-size: 15px;
  }

  .meta-tag {
    font-size: 12px;
  }

  .countdown {
    padding: 10px 12px;
  }

  .time-num {
    font-size: 16px;
  }

  .time-block {
    padding: 2px 6px;
    min-width: 30px;
  }

  .btn-buy {
    padding: 8px 14px;
    font-size: 12px;
  }

  .vip-requirement {
    font-size: 12px;
    padding: 6px 12px;
  }
}
</style>
